// --- LAYOUT, COMPONENTS, PARTS --- //
$(function () {
	// ---  LAYOUT --- //
	//fn_layout_main();

	// ---  COMPONENTS --- //
	fn_components_fullscreen_navigation();
	//fn_components_calendar();
	fn_components_subnavigation();
	fn_components_slider();
	fn_components_tabs();
	fn_components_select();
	fn_components_accordion();
	fn_components_gallery();
	//fn_components_google_map();



	// ---  PARTS --- //
	//fn_parts_wow();
	//fn_parts_full_height();
	//fn_parts_quantity_input();
	//fn_parts_slide_down_up();
	//fn_parts_more_text();
	fn_parts_dropdown();
	fn_parts_navigation_scroll_resize();
	fn_parts_is_in_viewport();
});


// --- MISC --- //
$(function () {
	nl_fn_scroll_to();
});

var resizeId;
// --- EVENTS --- //
$(window).resize(function(){
	fn_checkNavigationTrigger();
	clearTimeout(resizeId);
    resizeId = setTimeout(fn_parts_is_in_viewport(), 1000);
	//fn_parts_full_height();
});

$(document).scroll(function () {
    fn_parts_navigation_scroll_resize();
});

$(window).load(function () {
	fn_parts_dots();
    fn_components_map();
});